//TODO: rework to do proper event delegation with just one listener

export const onClickSelectors = (
	selectors: string,
	handler: ( event: MouseEvent, currentTarget: HTMLElement ) => void
) =>
	globalThis.addEventListener( 'click', ( event ) => {
		let currentTarget;
		if (
			( currentTarget = ( event.target as HTMLElement ).closest(
				selectors
			) )
		) {
			handler( event, currentTarget as HTMLElement );
		}
	} );

export const onDocumentReady = ( readyCallback: () => void ) => {
	if ( document.readyState !== 'loading' ) {
		readyCallback();
	} else {
		globalThis.addEventListener( 'DOMContentLoaded', readyCallback, false );
	}
};
